import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-900 text-white p-4 rounded-lg mb-6"
}
const _hoisted_5 = {
  key: 2,
  class: "grid grid-cols-1 md:grid-cols-2 gap-8"
}
const _hoisted_6 = { class: "flex flex-col bg-gray-800 rounded-lg p-6 shadow-lg product-info-container" }
const _hoisted_7 = { class: "flex justify-end mb-4" }
const _hoisted_8 = { class: "flex items-center space-x-1 bg-gray-700 bg-opacity-50 px-3 py-1 rounded-md followers-info" }
const _hoisted_9 = { class: "text-gray-300 text-sm" }
const _hoisted_10 = {
  key: 1,
  class: "mt-4 p-3 bg-gray-700 rounded-lg text-gray-300 text-center owner-message"
}
const _hoisted_11 = {
  key: 3,
  class: "bg-gray-800 rounded-lg p-8 text-center text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductGallery = _resolveComponent("ProductGallery")!
  const _component_ProductHeader = _resolveComponent("ProductHeader")!
  const _component_ProductInfo = _resolveComponent("ProductInfo")!
  const _component_ProductSellerInfo = _resolveComponent("ProductSellerInfo")!
  const _component_ProductActions = _resolveComponent("ProductActions")!
  const _component_ProductLightbox = _resolveComponent("ProductLightbox")!
  const _component_ReportModal = _resolveComponent("ReportModal")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "flex items-center text-gray-400 hover:text-blue-400 mb-6 transition-colors"
      }, _cache[8] || (_cache[8] = [
        _createElementVNode("span", { class: "mr-2" }, "←", -1),
        _createTextVNode(" Nazad na proizvode ")
      ])),
      (_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_ctx.product)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_ProductGallery, {
                  product: _ctx.product,
                  "current-image": _ctx.currentImage || '',
                  "api-url": _ctx.apiUrl || '',
                  "onUpdate:currentImage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentImage = $event)),
                  onOpenLightbox: _cache[2] || (_cache[2] = ($event: any) => (_ctx.lightboxOpen = true))
                }, null, 8, ["product", "current-image", "api-url"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ProductHeader, {
                    product: _ctx.product,
                    "format-price": _ctx.formatPrice
                  }, null, 8, ["product", "format-price"]),
                  _createVNode(_component_ProductInfo, {
                    product: _ctx.product,
                    "format-date": _ctx.formatDate
                  }, null, 8, ["product", "format-date"]),
                  _createVNode(_component_ProductSellerInfo, {
                    product: _ctx.product,
                    "is-current-user-product-owner": _ctx.isCurrentUserProductOwner,
                    onOpenReportModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showReportModal = true)),
                    onShowLoginRequiredToast: _ctx.showLoginRequiredToast
                  }, null, 8, ["product", "is-current-user-product-owner", "onShowLoginRequiredToast"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[10] || (_cache[10] = _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-blue-400\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4f906190><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\" data-v-4f906190></path><circle cx=\"9\" cy=\"7\" r=\"4\" data-v-4f906190></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\" data-v-4f906190></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\" data-v-4f906190></path></svg>", 1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.followersCount) + " " + _toDisplayString(_ctx.followersCount === 1 ? 'osoba prati' : 'osoba prati'), 1)
                    ])
                  ]),
                  (!_ctx.isCurrentUserProductOwner)
                    ? (_openBlock(), _createBlock(_component_ProductActions, {
                        key: 0,
                        following: _ctx.following,
                        "is-loading": _ctx.isLoading,
                        onContactSeller: _ctx.handleContactSeller,
                        onToggleFollow: _ctx.handleToggleFollow
                      }, null, 8, ["following", "is-loading", "onContactSeller", "onToggleFollow"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, " Ovo je vaš oglas. "))
                ])
              ]))
            : (_ctx.showNotFound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Proizvod nije pronađen. "))
              : _createCommentVNode("", true)
    ]),
    (_ctx.lightboxOpen && _ctx.currentImage && _ctx.product)
      ? (_openBlock(), _createBlock(_component_ProductLightbox, {
          key: 0,
          product: _ctx.product,
          "current-image": _ctx.currentImage,
          "api-url": _ctx.apiUrl || '',
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.lightboxOpen = false)),
          "onUpdate:currentImage": _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentImage = $event))
        }, null, 8, ["product", "current-image", "api-url"]))
      : _createCommentVNode("", true),
    (_ctx.showReportModal && _ctx.product)
      ? (_openBlock(), _createBlock(_component_ReportModal, {
          key: 1,
          "reported-user-id": _ctx.product.user.id,
          "reported-username": _ctx.product.user.username,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showReportModal = false)),
          onReportSubmitted: _ctx.handleReportSubmit
        }, null, 8, ["reported-user-id", "reported-username", "onReportSubmitted"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}